import { connect } from 'react-redux';

import Contribute from 'components/Contribute';
import * as actions from 'actions';
import { getMagazineContribute, getMagazineTextEditing, getMagazineEmojis, getInfoState } from 'selectors';

const mapStateToProps = state => {
  const magazineContribute = getMagazineContribute(state);
  const magazineContributeTextEditing = getMagazineTextEditing(state, 'magazineContribute');
  const isSubmitDisabled = magazineContributeTextEditing.isSubmitting || !magazineContribute.subject.length || !magazineContributeTextEditing.text.length;
  const successState = getInfoState(state, 'success');
  const isSuccessInfoBarVisible = successState.visible;
  const successInfoBarMessage = successState.message;
  const successInfoBarTitle = successState.title;

  return {
    ...magazineContributeTextEditing,
    ...magazineContribute,
    isSubmitDisabled,
    isSuccessInfoBarVisible,
    successInfoBarMessage,
    successInfoBarTitle,
    showsEmojis: getMagazineEmojis(state, 'magazineContribute').areVisible,
    title: __('members.magazine.titles.contribute'),
    isExpanded: true,
    isAutosized: true
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubjectUpdate: subject => {
      dispatch(actions.magazineContributeEditingUpdateSubject(subject));
    },
    onTextUpdate: text => {
      dispatch(actions.magazineContributeEditingUpdateText({ text }));
    },
    onSubmit: (subject, text) => {
      dispatch(actions.magazineArticleCreate(subject, text, __('members.magazine.contribute.successMessage')));
      dispatch(actions.magazineEmojisHide('magazineContribute'));
    },
    onWillUnmount: () => {
      dispatch(actions.magazineEmojisHide('magazineContribute'));
      dispatch(actions.magazineContributeEditingReset());
    },
    onEmojisToggled: showsEmojis => {
      if(showsEmojis) {
        dispatch(actions.magazineEmojisHide('magazineContribute'));
      }
      else {
        dispatch(actions.magazineEmojisShow('magazineContribute'));
      }
    },
    onEmojiSelected: (text, emojiShortName, selectionStart) => {
      dispatch(actions.magazineContributeEditingUpdateText({ text, emojiShortName, selectionStart }));
    },
    onDidMount: () => {
      dispatch(actions.infoShow('success', __('members.magazine.contribute.infoSubtitle'), __('members.magazine.contribute.infoTitle')));
    },
    onInfoBarClose: () => {
      dispatch(actions.infoClose('success'));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contribute);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Magazine/MagazineContribute/index.js
 **/